import { FaEnvelope, FaMapMarkedAlt, FaPhoneAlt } from "react-icons/fa";

const support = [
    {
        id: 1,
        icon: <FaMapMarkedAlt />,
        title: "Office Address",
        content: ["BroadConnect Solutions", "123 Broadband Ave, City, ZIP Code"],
    },
    {
        id: 2,
        icon: <FaPhoneAlt />,
        title: "Contact Support",
        content: ["+1-800-123-4567", "+1-888-987-6543 (24/7 Support)"],
    },
    {
        id: 3,
        icon: <FaEnvelope />,
        title: "Email Support",
        content: ["support@example.com", "inquiries@example.com"],
    },
];

export default support;